<template>
  <a-card :bordered="false" v-if="userinfo">
    <div class="account-center-avatarHolder">
      <div class="avatar">
        <img :src="userinfo.avatar ? userinfo.avatar : '/user.jpg'" />
      </div>
      <div class="username">姓名：{{ userinfo.nickname ? userinfo.nickname : '未填写' }}</div>
      <div class="bio" v-if="userinfo.ip">IP：{{ userinfo.ip }}</div>
      <div class="bio">性别：{{ userinfo.sex ? userinfo.sex : '未填写' }}</div>
      <div class="bio">邮箱：{{ userinfo.email ? userinfo.email : '未填写' }}</div>
      <div class="bio">手机号：{{ userinfo.email ? userinfo.phone : '未填写' }}</div>
    </div>
    <div class="account-center-detail">
      <p class="title">
        第三方账号
      </p>
      <p v-if="userinfo.oschina_token">oschina：{{ userinfo.oschina_token }}</p>
      <p v-if="userinfo.gitee_token">gitee：{{ userinfo.gitee_token }}</p>
      <p v-if="userinfo.github_token">github：{{ userinfo.github_token }}</p>
      <p v-if="userinfo.qq_token">QQ：{{ userinfo.qq_token }}</p>
      <p v-if="userinfo.wechat_token">Wechat：{{ userinfo.wechat_token }}</p>
      <template v-if="userinfo.real_auth === 1">
        <p class="title">
          实名认证
        </p>
        <p v-if="userinfo.real_name">姓名：{{ userinfo.real_name }}</p>
        <p v-if="userinfo.real_name">身份证号：{{ userinfo.real_id_card }}</p>
      </template>
    </div>
  </a-card>
</template>

<script>
export default {
    name: 'ModelDetail',
    props: {
        userinfo: {
            type: Object,
            default: () => null
        }
    },
    data () {
        return {}
    },
    mounted () {},
    methods: {
        /**
         * 提交按钮
         * form表单提交
         * @form
         */
        onOk () {
            return new Promise(resolve => {
                resolve(true)
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>

<style lang="less" scoped>
/deep/.ant-card-body {
    width: 300px;
    margin: 0 auto;
}
.avatar {
    margin-bottom: 15px;
    text-align: center;
}

.account-center-detail {
    margin-top: 1rem;
    .title {
        font-weight: bold;
        font-size: 1rem;
        color: #4a4a4a;
    }
}
</style>
